import React from 'react';

// Fallback for the top-level Sentry.ErrorBoundary. Reached when an error
// escapes rendering — including a stale-chunk failure that lazyWithRetry has
// already tried to reload past once. We offer a manual Reload (not an automatic
// one) so we never loop on a genuinely broken build; reloading still pulls the
// fresh index.html + new chunk hashes, which clears the common case.
export const AppErrorFallback: React.FC = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-5 px-6 text-center">
    <div className="space-y-1">
      <h1 className="text-xl text-gray-900">Something went wrong</h1>
      <p className="text-sm text-gray-500">
        Reloading usually fixes this — it pulls the latest version of the app.
      </p>
    </div>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-gray-700"
    >
      Reload page
    </button>
  </div>
);
